import { ReactNode } from "react";

// ---------------------- Props

interface BookingDetailsItemProps {
  title: string;
  children: ReactNode;
}

// ---------------------- Component

const BookingDetailsItem = ({ title, children }: BookingDetailsItemProps) => {
  // --------- JSX

  return (
    <>
      <div className="font-base mb-2 flex h-auto w-full flex-col items-start justify-start text-sm text-gray-800 dark:text-gray-200 xs:text-sm sm:text-base">
        <h3 className="text-sm font-bold text-gray-800 dark:text-gray-100 sm:text-base">{title}</h3>
        <div className="w-full">{children}</div>
      </div>
    </>
  );
};

export default BookingDetailsItem;
